import { useContext } from 'react';
import { DataContext } from '../../data/DataContext';
import { ImgError, ImgOk } from '../../img';

const redirectToThankYouPage = (event :any) => {
    event.preventDefault();
    if (window.top !== null && window.top !== undefined) {
        window.top.location.href = 'https://www.lafise.com/slh/automovil-seguro-plus/solicitud-recibida';
    } 
};

const Step4 = () => {

    const { AutoHN } = useContext(DataContext);

    const txt1Error = `Pero no te preocupes, hemos recibido tus datos relacionados a la cotización`;
    const txt2Error = 'En breve te contactaremos para confirmar la compra de tu póliza.';
    const txt3Error = 'Recuerda tener a mano la tarjeta de crédito o débito con la que confirmarás la compra de tu póliza de Auto Seguro Plus';

    const txt1OK = `Tu número de solicitud es: `;
    const txt2OK = 'En breve recibirás en tu correo electrónico una copia de tu oferta de seguro de automóvil.';
    const txt3OK = 'Así mismo, un ejecutivo de Seguros LAFISE te contactarán para confirmar la compra de tu póliza.';

    return (
        <>
            <div className='border-autohn pt-20 pr-20 pl-20 mt-20 step-autohn-4'>
                {AutoHN.saved && <div className='text-center'>
                    <span className='lbl-end-autohn'>
                        {txt1OK} 
                        <span className='lbl-end-autohn-title'>
                            {AutoHN.policyNumber}
                        </span>
                    </span>
                </div>
                }
                {!AutoHN.saved && <p className='lbl-end-autohn '>
                    {txt1Error}
                </p>}

                <div className='img-autohn mt-40 mb-40'>
                    {AutoHN.saved && <ImgOk />}
                    {!AutoHN.saved && <ImgError />}
                </div>
                <p className='lbl-end-autohn'>
                    {AutoHN.saved && txt2OK}
                    {!AutoHN.saved && txt2Error}
                </p>
                <p className='lbl-end-autohn'>
                    {AutoHN.saved && txt3OK}
                    {!AutoHN.saved && txt3Error}
                </p>
                <div className='img-autohn mt-20 mb-50'>
                    <button className='button-finish-autohn' onClick={redirectToThankYouPage}>
                        {!AutoHN.saved && 'Terminar'}
                        {AutoHN.saved && 'Finalizar'}
                    </button>
                </div>
            </div>
        </>

    );
}

export { Step4 }